import axiosInstance from 'plugins/axios';
import { IListAccountsPayload, IAccountPayload } from 'types/account';
import { IBodyResponse } from 'types/type.global';
import { objectToFormData } from 'utils/helpers';

export const listAccounts = async (
    params: IListAccountsPayload
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get('admin/admin_managements', {
        params,
    });
    return response.data;
};

export const createAccount = async (
    data: IAccountPayload
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.post(
        'admin/admin_managements',
        objectToFormData({
            admin_management: data,
        })
    );
    return response.data;
};

export const updateAccount = async (
    id: number,
    data: IAccountPayload
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.put(
        `admin/admin_managements/${id}`,
        objectToFormData({
            admin_management: data,
        })
    );
    return response.data;
};

export const deleteAccount = async (
    id: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.delete(
        `admin/admin_managements/${id}`
    );
    return response.data;
};

export const getAccountInfo = async (
    id: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(`admin/admin_managements/${id}`);
    return response.data;
};

export const exportAccounts = async (
    params: IListAccountsPayload
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
    const response = await axiosInstance.get(
        'admin/admin_managements/export_data',
        {
            params,
            responseType: 'blob',
        }
    );

    return response.data;
};
